import { PaletteMode } from '@mui/material';
import { createContext, FC, useEffect, useMemo, useState } from 'react';
import { defaultMode } from '../../theme';
import restoreColorMode from '../../utils/restoreColorMode';
import storeColorMode from '../../utils/storeColorMode';
import {
  ColorModeContextValue,
  ColorModeProviderProps,
} from '../../types/colorMode';

const ColorModeContext = createContext<ColorModeContextValue>({
  mode: defaultMode,
  changeMode: () => {},
});

export const ColorModeProvider: FC<ColorModeProviderProps> = ({ children }) => {
  const [mode, setMode] = useState<PaletteMode>(defaultMode);

  useEffect(() => {
    const restoredColorMode = restoreColorMode();
    if (restoredColorMode) setMode(restoredColorMode);
  }, []);

  const saveColorMode = (updatedColorMode: PaletteMode): void => {
    storeColorMode(updatedColorMode);
    setMode(updatedColorMode);
  };

  const memoProps = useMemo(
    () => ({
      mode,
      changeMode: saveColorMode,
    }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={memoProps}>
      {children}
    </ColorModeContext.Provider>
  );
};

export const ColorModeConsumer = ColorModeContext.Consumer;
export default ColorModeContext;
